import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'FrequentlyAskedQuestion',
    column_type: 'id',
  },
  created_at: {
    model_name: 'FrequentlyAskedQuestion',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'FrequentlyAskedQuestion',
    column_type: 'datetime',
  },
  question: {
    model_name: 'FrequentlyAskedQuestion',
    column_type: 'string',
  },
  position: {
    model_name: 'FrequentlyAskedQuestion',
    column_type: 'integer',
  },
  answer: {
    model_name: 'FrequentlyAskedQuestion',
    column_type: 'text',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
